import axios from 'axios';
import store from '../redux/store/store';
// API URL
const API_CATEGORY_URL = import.meta.env.VITE_API_URL;

// API isteklerini yöneten servis
export const categoryService = {
  // Tüm kategorileri alma
  getCategoriesApi: async (token, page,searchTerm,authUserId,placeId) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get(`${API_CATEGORY_URL}/Category`, {
        headers: {
          Authorization: `Bearer ${userToken}`
        },
        params: {
          page: page ,
          name:searchTerm,
          userId:authUserId,
          isMissingUpperCategory:true,
          MarketPlaceId:placeId?.marketPlaceId,
          EcommercePlaceId:placeId?.ecommercePlaceId,
        }
      });
      return response;
    } catch (error) {
      console.error("Kategoriler alınırken bir hata oluştu:", error);
      throw error;
    }
  },

//dropdownlar için kategorileri alma alt kategorileride çekecek
  getCategoriesApiForDropdown: async (token, page,searchTerm,authUserId) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get(`${API_CATEGORY_URL}/Category`, {
        headers: {
          Authorization: `Bearer ${userToken}`
        },
        params: {
          page: page ,
          name:searchTerm,
          userId:authUserId,
          isMissingUpperCategory:false,
          closePagination:true,
          withCategory:1,
          withMarketpleaces:1
        }
      });
      return response;
    } catch (error) {
      console.error("Kategoriler alınırken bir hata oluştu:", error);
      throw error;
    }
  },
  

  // Kategori ekleme
  addCategoryApi: async (categoryData,token) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.post(`${API_CATEGORY_URL}/Category`, categoryData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      return response; 
    } catch (error) {
      
      console.error("Kategori eklenirken bir hata oluştu:", error);
      throw error; 
    }
  },

  // Kategori silme
 // Kategori silme işlemi: sadece belirli kategori
 deleteCategoryApi: async (categoryId, token) => {
  try {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    const response = await axios.delete(
      `${API_CATEGORY_URL}/Category?id=${categoryId}`,
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
        }
      }
    );
    return response;
  } catch (error) {
   
    console.error("Kategori silinirken bir hata oluştu:", error);
    throw error;
  }
},

// Kategori ve tüm alt kategorilerini silme işlemi
deleteCategoryWithSubCategoriesApi: async (categoryId,token) => {
  try {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    const response = await axios.delete(`${API_CATEGORY_URL}/Category/DeleteCategoryWithSubCategories`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      params: { id: categoryId } 
    });
    return response.data;
  } catch (error) {
   
    console.error("Kategori ve alt kategoriler silinirken bir hata oluştu:", error);
    throw error;
  }
},
updateCategoryApi: (data,token) => {
  const userToken = store.getState()?.auth?.user?.accessToken?.token;
  return axios.put(
    `${API_CATEGORY_URL}/Category`,
    data,
    {
      headers: {
        Authorization: `Bearer ${userToken}`
      }
    }
  );
  
},






getCategoriyVariantApi: async (userId,token) => {
  try {
    const response = await axios.get(`${API_CATEGORY_URL}/PlaceCategoryVariant`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        userid: userId, 
      },
    });  
    return response;  
  } catch (error) {
    console.error("Kategoriler alınırken bir hata oluştu:", error);
    throw error; 
  }
},

// Kategori ekleme
addCategoryVariantApi: async (categoryData,token) => {
  try {
  
    const response = await axios.post(`${API_CATEGORY_URL}/PlaceCategoryVariant`, categoryData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response; 
  } catch (error) {
   
    console.error("Kategori eklenirken bir hata oluştu:", error);
    throw error; 
  }
},



deleteCategoryVariantApi: async (categoryId, token) => {
try {
  const response = await axios.delete(`${API_CATEGORY_URL}/PlaceCategoryVariant`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: { id: categoryId } 
  });
  return response;
} catch (error) {
 
  console.error("Kategori silinirken bir hata oluştu:", error);
  throw error;
}
},
  
};

export default categoryService;
